import React, { Component } from 'react';

class SidebarHeader extends Component {

  render() {
    return (
      <div className="sidebar-header" style={{
        padding: "6px 0",
      }}>
      </div>
    )
  }
}

export default SidebarHeader;



// WEBPACK FOOTER //
// ./src/components/SidebarHeader/SidebarHeader.js